import { makeEntityStringId } from 'app/types/entity';
import { makeGuid } from 'app/types/guid';

/**
 * Hard coded Engoo Korea Id. This is here specifically to allow for checking
 * if the current brand is Korea when deciding what to show for the Terms Agreement.
 * In order to fully support Korean terms flexibly in an arbitrary brand, a much
 * more robust front and backend for brand terms needs to be developed. In the
 * interim, directly checking the brand's ID is sufficient. Note that before
 * it is possible to support Third Party Sign up, the more robust system for dealing
 * with terms must be in place.
 */
export const ENGOO_KOREA_BRAND_ID = makeEntityStringId(makeGuid('5a4657f2-e151-4c48-9cce-000000000006'));

export const ENGOO_GLOBAL_BRAND_ID = makeEntityStringId(makeGuid('5a4657f2-e151-4c48-9cce-000000000002'));
